import { render, staticRenderFns } from "./vehicleInspection.vue?vue&type=template&id=65f95505&"
import script from "./vehicleInspection.vue?vue&type=script&lang=js&"
export * from "./vehicleInspection.vue?vue&type=script&lang=js&"
import style0 from "./vehicleInspection.vue?vue&type=style&index=0&id=65f95505&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports